import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { MapToolsService } from '../../../services/map-tools.service';
import { RutasService } from 'src/app/shared/services/rutas-service/rutas.service';
import { PuntosService } from 'src/app/shared/services/puntos-service/puntos.service';
import { ListaMovilesService } from 'src/app/shared/services/lista-moviles.service';
import { Ruta, RutaOpcion } from 'src/app/models/ruta.model';
import { PuntoCliente } from 'src/app/models/punto-cliente.model';

@Component({
  selector: 'app-tools-rutas',
  templateUrl: './tools-rutas.component.html',
  styleUrls: ['./tools-rutas.component.scss']
})
export class ToolsRutasComponent implements OnInit {

  mostrarTodos: boolean = true;
  event: Event;

  @Output() eventClose = new EventEmitter<Event>();

  rutas: Ruta[] = [];
  rutasFiltered: Ruta[] = [];

  // Variables para crear nueva ruta
  mostrarFormularioNuevaRuta: boolean = false;
  nombreNuevaRuta: string = '';

  // Modo de operación: 'punto-a-punto' | 'multiples-puntos' | 'seleccion-mapa' | 'recorrido-vehiculo'
  modoOperacion: 'punto-a-punto' | 'multiples-puntos' | 'seleccion-mapa' | 'recorrido-vehiculo' = 'punto-a-punto';

  // Variables para modo punto a punto
  puntoOrigenSeleccionado: PuntoCliente | null = null;
  puntoDestinoSeleccionado: PuntoCliente | null = null;

  // Variables para modo múltiples puntos
  puntosMultiplesSeleccionados: PuntoCliente[] = [];
  puntosMultiplesFiltrados: PuntoCliente[] = [];

  // Variables para modo selección en mapa
  puntosMapaSeleccionados: { lat: number, lng: number }[] = [];
  seleccionMapaActiva: boolean = false;

  // Variables para modo recorrido de vehículo
  vehiculosDisponibles: any[] = [];
  vehiculoSeleccionado: any = null;
  fechaDesdeRecorrido: Date | null = null;
  fechaHastaRecorrido: Date | null = null;
  cargandoRecorrido: boolean = false;
  puntosRecorrido: { lat: number, lng: number }[] = [];
  recorridoCargado: boolean = false;

  opcionesRuta: RutaOpcion[] = [];
  opcionSeleccionada: number = 0;
  calculandoRuta: boolean = false;
  errorRuta: string = '';

  // Puntos disponibles del cliente
  puntosDisponibles: PuntoCliente[] = [];
  puntosOrigenFiltrados: PuntoCliente[] = [];
  puntosDestinoFiltrados: PuntoCliente[] = [];

  // Ruta en edición (si existe, estamos editando en lugar de crear)
  rutaEnEdicion: Ruta | null = null;

  // Variables para arrastre del panel
  isDragging: boolean = false;
  offsetX: number = 0;
  offsetY: number = 0;
  currentX: number = 0;
  currentY: number = 0;

  constructor(
    private gtp: Gtp,
    private mapToolsService: MapToolsService,
    private rutasService: RutasService,
    private puntosService: PuntosService,
    private listaMovilesService: ListaMovilesService
  ) { }

  ngOnInit() {
    this.cargarRutas();
    this.cargarPuntosCliente();
    this.cargarVehiculos();

    // Suscribirse a puntos seleccionados en el mapa
    this.mapToolsService.getPuntoRutaSeleccionadoObs().subscribe(punto => {
      if (this.seleccionMapaActiva && this.modoOperacion === 'seleccion-mapa') {
        this.puntosMapaSeleccionados.push(punto);
        this.opcionesRuta = [];

        // Actualizar los puntos temporales en el mapa INMEDIATAMENTE
        this.actualizarPuntosTemporales();
      }
    });
  }

  ngOnDestroy() {
    // Guardar estado de rutas al destruir el componente
    this.rutasService.setRutas(this.rutas);

    // Desactivar modo de selección en mapa
    this.mapToolsService.setSeleccionRutasActiva(false);

    // Limpiar puntos temporales
    this.mapToolsService.clearPuntosTemporalesRuta();

    // Remover listeners de arrastre
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  /**
   * Inicia el arrastre del panel
   */
  onMouseDown(event: MouseEvent, panel: HTMLElement): void {
    // Solo permitir arrastre con click izquierdo
    if (event.button !== 0) return;

    this.isDragging = true;

    // Obtener la posición actual del panel
    const rect = panel.getBoundingClientRect();

    // Calcular el offset desde la posición del mouse hasta la esquina del panel
    this.offsetX = event.clientX - rect.left;
    this.offsetY = event.clientY - rect.top;

    // Agregar clases de arrastre
    panel.classList.add('dragging');

    // Agregar listeners globales
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseUp);

    // Prevenir selección de texto
    event.preventDefault();
  }

  /**
   * Maneja el movimiento del mouse durante el arrastre
   */
  onMouseMove = (event: MouseEvent): void => {
    if (!this.isDragging) return;

    // Calcular nueva posición
    this.currentX = event.clientX - this.offsetX;
    this.currentY = event.clientY - this.offsetY;

    // Obtener el panel
    const panel = document.querySelector('.tool-rutas') as HTMLElement;
    if (!panel) return;

    // Obtener dimensiones de la ventana y del panel
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const panelWidth = panel.offsetWidth;
    const panelHeight = panel.offsetHeight;

    // Limitar la posición para que no se salga de la pantalla
    const maxX = windowWidth - panelWidth;
    const maxY = windowHeight - panelHeight;

    this.currentX = Math.max(0, Math.min(this.currentX, maxX));
    this.currentY = Math.max(0, Math.min(this.currentY, maxY));

    // Aplicar la nueva posición
    panel.style.left = this.currentX + 'px';
    panel.style.top = this.currentY + 'px';
  };

  /**
   * Finaliza el arrastre del panel
   */
  onMouseUp = (event: MouseEvent): void => {
    if (!this.isDragging) return;

    this.isDragging = false;

    // Remover clase de arrastre
    const panel = document.querySelector('.tool-rutas') as HTMLElement;
    if (panel) {
      panel.classList.remove('dragging');
    }

    // Remover listeners globales
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  };

  closeTab(event: Event): void {
    this.eventClose.emit(event);
  }

  /**
   * Carga las rutas desde el servicio
   */
  cargarRutas(): void {
    // Primero suscribirse al observable
    this.rutasService.getRutasObs().subscribe(rutas => {
      this.rutas = rutas.sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.rutasFiltered = this.rutas;
    });

    // Luego cargar desde el servidor si no hay rutas
    if (this.rutasService.rutas.length === 0) {
      console.log('📊 Cargando rutas desde el servidor...');
      this.rutasService.cargarRutasDesdeServidor()
        .then(() => {
          console.log('✅ Rutas cargadas desde el servidor');
        })
        .catch(error => {
          console.error('❌ Error al cargar rutas:', error);
        });
    }
  }

  /**
   * Carga los puntos del cliente
   */
  cargarPuntosCliente(): void {
    this.puntosService.getGrupos(true).subscribe(res => {
      let puntos: PuntoCliente[] = [];
      Object.values(res).forEach((grupo: any) => {
        if (grupo.puntos && Array.isArray(grupo.puntos)) {
          puntos = puntos.concat(grupo.puntos.map((p: any) => new PuntoCliente(p)));
        }
      });
      this.puntosDisponibles = puntos.sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.puntosOrigenFiltrados = [...this.puntosDisponibles];
      this.puntosDestinoFiltrados = [...this.puntosDisponibles];
      this.puntosMultiplesFiltrados = [...this.puntosDisponibles]; // Inicializar puntos múltiples
    });
  }

  /**
   * Filtra las rutas vía el input
   */
  filterRutas(query: string): void {
    let res = this.rutas.filter(r =>
      r.nombre.toLocaleLowerCase().includes(query.toLocaleLowerCase())
    );
    this.rutasFiltered = (query === '') ? this.rutas : res;
  }

  /**
   * Muestra / Oculta una ruta
   *
   * ==================== 💰 OPTIMIZACIÓN DE COSTOS ====================
   * 🔴 RECÁLCULO AUTOMÁTICO DESACTIVADO
   *
   * Ahorro: ~$20 USD/mes
   *
   * El código anterior recalculaba automáticamente cada ruta al mostrarla,
   * causando llamadas innecesarias a la API de Google.
   *
   * ⚙️ PARA REACTIVAR RECÁLCULO AUTOMÁTICO:
   * Descomenta el bloque de código marcado con "CÓDIGO ANTIGUO" abajo
   * y comenta la nueva implementación.
   * ================================================================
   */
  showHideOneRuta(): void {
    // ✅ NUEVA IMPLEMENTACIÓN (OPTIMIZADA - Sin recálculo automático)
    // Solo actualiza la visibilidad de las rutas
    this.rutasService.setRutas(this.rutasFiltered);

    /* ⚠️ CÓDIGO ANTIGUO - RECÁLCULO AUTOMÁTICO (Comentado para ahorrar costos)
    //
    // 💰 COSTO: Cada vez que se muestra una ruta sin opciones = 1 llamada a API
    // Si un usuario tiene 10 rutas guardadas y las muestra = 10 llamadas
    //
    // DESCOMENTA ESTE BLOQUE SOLO SI NECESITAS RECÁLCULO AUTOMÁTICO:

    this.rutasFiltered.forEach(ruta => {
      if (ruta.visible && (!ruta.opciones || ruta.opciones.length === 0) && ruta.puntoOrigen && ruta.puntoDestino) {
        // Calcular la ruta automáticamente
        console.log('🗺️ Calculando ruta automáticamente para:', ruta.nombre);

        const waypoints = ruta.puntosIntermedios || [];

        this.rutasService.calcularRutas(ruta.puntoOrigen, ruta.puntoDestino, waypoints)
          .then(opciones => {
            console.log('✅ Opciones de ruta calculadas:', opciones);
            ruta.opciones = opciones;
            ruta.rutaSeleccionada = 0; // Seleccionar la primera opción por defecto
            this.rutasService.updateRuta(ruta);
          })
          .catch(error => {
            console.error('❌ Error al calcular ruta:', error);
          });
      }
    });

    this.rutasService.setRutas(this.rutasFiltered);

    FIN CÓDIGO ANTIGUO */
  }

  /**
   * Muestra / Oculta todas las rutas
   */
  showHideAllRutas(state: boolean): void {
    let newlist = this.rutasFiltered.map(ruta => {
      ruta.visible = state;
      return ruta;
    });
    this.mostrarTodos = !state;
    this.rutasFiltered = newlist;
    this.rutas = this.rutasFiltered;
    this.rutasService.setRutas(this.rutasFiltered);
  }

  /**
   * Centra el mapa en una ruta
   */
  irARuta(ruta: Ruta): void {
    if (ruta.opciones && ruta.opciones.length > 0) {
      const opcion = ruta.opciones[ruta.rutaSeleccionada];
      if (opcion && opcion.puntos && opcion.puntos.length > 0) {
        // Calcular el centro de la ruta
        const latSum = opcion.puntos.reduce((sum, p) => sum + p.lat, 0);
        const lngSum = opcion.puntos.reduce((sum, p) => sum + p.lng, 0);
        const center = {
          latitud: latSum / opcion.puntos.length,
          longitud: lngSum / opcion.puntos.length,
          zoom: 12
        };
        this.mapToolsService.setCenterMapa(center);
      }
    }
  }

  /**
   * Elimina una ruta
   */
  editarRuta(ruta: Ruta, event: Event): void {
    event.stopPropagation();

    // Mostrar el formulario de edición
    this.mostrarFormularioNuevaRuta = true;

    // Cargar los datos de la ruta a editar
    this.nombreNuevaRuta = ruta.nombre;
    this.opcionesRuta = ruta.opciones || [];
    this.opcionSeleccionada = ruta.rutaSeleccionada || 0;

    // Establecer los puntos
    if (ruta.puntoOrigen) {
      this.puntoOrigenSeleccionado = ruta.puntoOrigen as any;
    }
    if (ruta.puntoDestino) {
      this.puntoDestinoSeleccionado = ruta.puntoDestino as any;
    }

    // Si tiene puntos intermedios, cargarlos
    if (ruta.puntosIntermedios && ruta.puntosIntermedios.length > 0) {
      this.modoOperacion = 'multiples-puntos';
      // Construir la lista de puntos seleccionados (origen + intermedios + destino)
      this.puntosMultiplesSeleccionados = [
        ruta.puntoOrigen as any,
        ...ruta.puntosIntermedios as any[],
        ruta.puntoDestino as any
      ];
      this.actualizarPuntosTemporales();
    } else {
      this.modoOperacion = 'punto-a-punto';
    }

    // Mostrar la ruta temporal en el mapa
    if (this.opcionesRuta.length > 0) {
      if (ruta.puntosIntermedios && ruta.puntosIntermedios.length > 0) {
        this.mostrarRutaTemporalConWaypoints(this.opcionesRuta[this.opcionSeleccionada], ruta.puntosIntermedios);
      } else {
        this.mostrarRutaTemporalEnMapa(this.opcionesRuta[this.opcionSeleccionada]);
      }
    }

    // 🗺️ Mostrar los puntos del polyline guardado en el mapa (para visualizar el trazado completo)
    if (ruta.polyline && ruta.polyline.length > 0) {
      console.log('🗺️ Mostrando', ruta.polyline.length, 'puntos del polyline guardado');
      // Convertir polyline a puntos temporales para el mapa - MOSTRAR TODOS
      const puntosTemporalesPolyline = ruta.polyline.map((punto: any, index: number) => ({
        numero: index + 1,
        nombre: index === 0 ? 'Inicio' :
                index === ruta.polyline.length - 1 ? 'Fin' :
                '',
        latitud: punto.lat,
        longitud: punto.lng,
        tipo: index === 0 ? 'origen' :
              index === ruta.polyline.length - 1 ? 'destino' :
              'intermedio',
        esPolylinePoint: true // Marcar para diferenciar
      }));

      // ✅ Mostrar TODOS los puntos del polyline
      this.mapToolsService.setPuntosTemporalesRuta(puntosTemporalesPolyline);
    }

    // Guardar referencia a la ruta que se está editando
    this.rutaEnEdicion = ruta;
  }

  eliminarRuta(ruta: Ruta, event: Event): void {
    event.stopPropagation();
    if (confirm(`¿Está seguro que desea eliminar la ruta "${ruta.nombre || 'Sin nombre'}"?`)) {
      // Si la ruta tiene codRuta, eliminarla del servidor
      if (ruta.codRuta) {
        this.rutasService.eliminarRutaDelServidor(ruta)
          .then(() => {
            console.log('✅ Ruta eliminada del servidor');
          })
          .catch(error => {
            console.error('❌ Error al eliminar ruta del servidor:', error);
            // Aun así, eliminarla localmente
            this.rutasService.deleteRuta(ruta.id);
          });
      } else {
        // Solo eliminarla localmente si no tiene codRuta
        this.rutasService.deleteRuta(ruta.id);
      }
    }
  }

  /**
   * Muestra el formulario para crear nueva ruta
   */
  mostrarFormularioCrearRuta(): void {
    this.mostrarFormularioNuevaRuta = true;
    this.resetFormularioNuevaRuta();
  }

  /**
   * Oculta el formulario de nueva ruta
   */
  cancelarNuevaRuta(): void {
    this.mostrarFormularioNuevaRuta = false;
    this.resetFormularioNuevaRuta();
    // Limpiar la ruta temporal del mapa
    this.rutasService.clearRutaTemporal();
    // Desactivar selección en mapa
    this.mapToolsService.setSeleccionRutasActiva(false);
  }

  /**
   * Resetea el formulario de nueva ruta
   * Limpia todos los campos según el modo de operación
   */
  resetFormularioNuevaRuta(): void {
    this.nombreNuevaRuta = '';
    this.modoOperacion = 'punto-a-punto';

    // Limpiar modo punto a punto
    this.puntoOrigenSeleccionado = null;
    this.puntoDestinoSeleccionado = null;

    // Limpiar modo múltiples puntos
    this.puntosMultiplesSeleccionados = [];
    this.puntosMultiplesFiltrados = [];

    // Limpiar modo selección en mapa
    this.puntosMapaSeleccionados = [];
    this.seleccionMapaActiva = false;

    // Limpiar modo recorrido de vehículo
    this.vehiculoSeleccionado = null;
    this.fechaDesdeRecorrido = null;
    this.fechaHastaRecorrido = null;
    this.puntosRecorrido = [];
    this.recorridoCargado = false;
    this.cargandoRecorrido = false;

    this.opcionesRuta = [];
    this.opcionSeleccionada = 0;
    this.errorRuta = '';

    // Limpiar referencia a ruta en edición
    this.rutaEnEdicion = null;

    // Limpiar la ruta temporal del mapa
    this.rutasService.clearRutaTemporal();
    // Limpiar puntos temporales del mapa
    this.mapToolsService.clearPuntosTemporalesRuta();
  }

  /**
   * Cambia el modo de operación
   * Limpia todos los campos del modo anterior antes de cambiar
   */
  cambiarModoOperacion(modo: 'punto-a-punto' | 'multiples-puntos' | 'seleccion-mapa' | 'recorrido-vehiculo'): void {
    console.log('🔄 Cambiando modo de:', this.modoOperacion, 'a:', modo);

    // Limpiar TODOS los datos de modos previos antes de cambiar
    this.puntoOrigenSeleccionado = null;
    this.puntoDestinoSeleccionado = null;
    this.puntosMultiplesSeleccionados = [];
    this.puntosMultiplesFiltrados = [];
    this.puntosMapaSeleccionados = [];
    this.vehiculoSeleccionado = null;
    this.fechaDesdeRecorrido = null;
    this.fechaHastaRecorrido = null;
    this.puntosRecorrido = [];
    this.recorridoCargado = false;
    this.cargandoRecorrido = false;

    // Cambiar el modo
    this.modoOperacion = modo;

    // Solo limpiar opciones de ruta si NO estamos editando
    // En edición, queremos mantener las opciones calculadas
    if (!this.rutaEnEdicion) {
      this.opcionesRuta = [];
    }

    this.errorRuta = '';
    this.rutasService.clearRutaTemporal();

    // Limpiar puntos temporales al cambiar de modo
    this.mapToolsService.clearPuntosTemporalesRuta();

    // Activar/desactivar selección en mapa según el nuevo modo
    if (modo === 'seleccion-mapa') {
      this.seleccionMapaActiva = true;
      this.mapToolsService.setSeleccionRutasActiva(true);
      console.log('✅ Modo selección-mapa activado');
    } else {
      this.seleccionMapaActiva = false;
      this.mapToolsService.setSeleccionRutasActiva(false);

      // Si hay origen/destino seleccionados en punto-a-punto, mostrarlos
      if (modo === 'punto-a-punto') {
        this.actualizarPuntosTemporalesPuntoAPunto();
        console.log('✅ Modo punto-a-punto activado');
      } else if (modo === 'recorrido-vehiculo') {
        console.log('✅ Modo recorrido-vehiculo activado - Esperando selección de vehículo');
      }
    }
  }

  /**
   * Verifica si se puede calcular la ruta según el modo actual
   */
  puedeCalcularRuta(): boolean {
    switch (this.modoOperacion) {
      case 'punto-a-punto':
        return this.puntoOrigenSeleccionado !== null && this.puntoDestinoSeleccionado !== null;
      case 'multiples-puntos':
        return this.puntosMultiplesSeleccionados.length >= 2;
      case 'seleccion-mapa':
        return this.puntosMapaSeleccionados.length >= 2;
      default:
        return false;
    }
  }

  /**
   * Filtra puntos de origen
   */
  filtrarPuntosOrigen(query: string): void {
    if (query === '') {
      this.puntosOrigenFiltrados = [...this.puntosDisponibles];
    } else {
      this.puntosOrigenFiltrados = this.puntosDisponibles.filter(p =>
        p.nombre.toLocaleLowerCase().includes(query.toLocaleLowerCase())
      );
    }
  }

  /**
   * Filtra puntos de destino
   */
  filtrarPuntosDestino(query: string): void {
    if (query === '') {
      this.puntosDestinoFiltrados = [...this.puntosDisponibles];
    } else {
      this.puntosDestinoFiltrados = this.puntosDisponibles.filter(p =>
        p.nombre.toLocaleLowerCase().includes(query.toLocaleLowerCase())
      );
    }
  }

  /**
   * Selecciona un punto de origen
   */
  seleccionarPuntoOrigen(punto: PuntoCliente): void {
    this.puntoOrigenSeleccionado = punto;
    this.opcionesRuta = [];
    this.actualizarPuntosTemporalesPuntoAPunto();
  }

  /**
   * Selecciona un punto de destino
   */
  seleccionarPuntoDestino(punto: PuntoCliente): void {
    this.puntoDestinoSeleccionado = punto;
    this.opcionesRuta = [];
    this.actualizarPuntosTemporalesPuntoAPunto();
  }

  /**
   * Actualiza los puntos temporales para modo punto-a-punto
   */
  private actualizarPuntosTemporalesPuntoAPunto(): void {
    let puntosTemp: any[] = [];

    if (this.puntoOrigenSeleccionado) {
      puntosTemp.push({
        numero: 1,
        nombre: this.puntoOrigenSeleccionado.nombre,
        latitud: this.puntoOrigenSeleccionado.latitud,
        longitud: this.puntoOrigenSeleccionado.longitud,
        tipo: 'origen',
        modo: 'punto-a-punto'
      });
    }

    if (this.puntoDestinoSeleccionado) {
      puntosTemp.push({
        numero: 2,
        nombre: this.puntoDestinoSeleccionado.nombre,
        latitud: this.puntoDestinoSeleccionado.latitud,
        longitud: this.puntoDestinoSeleccionado.longitud,
        tipo: 'destino',
        modo: 'punto-a-punto'
      });
    }

    this.mapToolsService.setPuntosTemporalesRuta(puntosTemp);
  }

  /**
   * Filtra puntos para modo múltiples puntos
   */
  filtrarPuntosMultiples(query: string): void {
    if (query === '') {
      this.puntosMultiplesFiltrados = [...this.puntosDisponibles];
    } else {
      this.puntosMultiplesFiltrados = this.puntosDisponibles.filter(p =>
        p.nombre.toLocaleLowerCase().includes(query.toLocaleLowerCase())
      );
    }
  }

  /**
   * Inicializa la lista de puntos filtrados
   */
  private inicializarPuntosMultiples(): void {
    this.puntosMultiplesFiltrados = [...this.puntosDisponibles];
  }

  /**
   * Agrega un punto al modo múltiples puntos
   */
  agregarPuntoMultiple(punto: PuntoCliente): void {
    // Verificar que no esté ya agregado
    const yaExiste = this.puntosMultiplesSeleccionados.some(p => p.gid === punto.gid);
    if (!yaExiste) {
      this.puntosMultiplesSeleccionados.push(punto);
      this.opcionesRuta = [];

      // Actualizar los puntos temporales en el mapa INMEDIATAMENTE
      this.actualizarPuntosTemporales();
    }
  }

  /**
   * Verifica si un punto ya está agregado en la lista de seleccionados
   */
  isPuntoYaAgregado(punto: PuntoCliente): boolean {
    return this.puntosMultiplesSeleccionados.some(p => p.gid === punto.gid);
  }

  /**
   * Quita un punto del modo múltiples puntos
   */
  quitarPuntoMultiple(index: number): void {
    this.puntosMultiplesSeleccionados.splice(index, 1);
    this.opcionesRuta = [];

    // Actualizar los puntos temporales en el mapa
    this.actualizarPuntosTemporales();
  }

  /**
   * Limpia todos los puntos del modo múltiples puntos
   */
  limpiarPuntosMultiples(): void {
    this.puntosMultiplesSeleccionados = [];
    this.puntosMultiplesFiltrados = [];
    this.opcionesRuta = [];

    // Limpiar puntos temporales del mapa
    this.mapToolsService.clearPuntosTemporalesRuta();
  }

  /**
   * Quita un punto del modo selección en mapa
   */
  quitarPuntoMapa(index: number): void {
    this.puntosMapaSeleccionados.splice(index, 1);
    this.opcionesRuta = [];

    // Actualizar los puntos temporales en el mapa
    this.actualizarPuntosTemporales();
  }

  /**
   * Limpia todos los puntos del modo selección en mapa
   */
  limpiarPuntosMapa(): void {
    this.puntosMapaSeleccionados = [];
    this.opcionesRuta = [];

    // Limpiar puntos temporales del mapa
    this.mapToolsService.clearPuntosTemporalesRuta();
  }

  /**
   * Limpia los datos de filtro de recorrido de vehículo
   * Se llama cuando se cancela o se cambia de modo
   */
  limpiarFiltrosRecorrido(): void {
    console.log('🧹 Limpiando filtros de recorrido...');

    this.vehiculoSeleccionado = null;
    this.fechaDesdeRecorrido = null;
    this.fechaHastaRecorrido = null;
    this.puntosRecorrido = [];
    this.recorridoCargado = false;
    this.cargandoRecorrido = false;
    this.errorRuta = '';

    // Limpiar puntos temporales del mapa
    this.mapToolsService.clearPuntosTemporalesRuta();

    console.log('✅ Filtros de recorrido limpiados');
  }

  /**
   * Método público para agregar punto desde el mapa (será llamado desde mapa-full)
   */
  agregarPuntoDesdeMapaClick(lat: number, lng: number): void {
    if (this.seleccionMapaActiva && this.modoOperacion === 'seleccion-mapa') {
      this.puntosMapaSeleccionados.push({ lat, lng });
      this.opcionesRuta = [];
    }
  }

  /**
   * Calcula las rutas según el modo de operación actual
   */
  async calcularRutas(): Promise<void> {
    this.calculandoRuta = true;
    this.errorRuta = '';

    try {
      switch (this.modoOperacion) {
        case 'punto-a-punto':
          await this.calcularRutaPuntoAPunto();
          break;
        case 'multiples-puntos':
          await this.calcularRutaMultiplesPuntos();
          break;
        case 'seleccion-mapa':
          await this.calcularRutaSeleccionMapa();
          break;
      }

      // Limpiar los puntos temporales ya que ahora se mostrará la ruta calculada
      this.mapToolsService.clearPuntosTemporalesRuta();

      // Marcar automáticamente la mejor ruta (primera opción) en el mapa
      // IMPORTANTE: Ya no llamamos mostrarRutaTemporalEnMapa aquí porque
      // los métodos calcularRutaMultiplesPuntos y calcularRutaSeleccionMapa
      // ya llaman a mostrarRutaTemporalConWaypoints con todos los puntos
      console.log('🗺️ Opciones de ruta después de calcular:', this.opcionesRuta.length);
      console.log('📝 Nombre de ruta:', this.nombreNuevaRuta);
      console.log('🎯 Modo operación:', this.modoOperacion);

      if (this.opcionesRuta.length > 0 && this.modoOperacion === 'punto-a-punto') {
        this.opcionSeleccionada = 0;
        this.mostrarRutaTemporalEnMapa(this.opcionesRuta[0]);
      }
    } catch (error) {
      console.error('❌ Error al calcular ruta:', error);
      // Mostrar el mensaje de error detallado del servicio
      if (typeof error === 'string') {
        this.errorRuta = error;
      } else if (error instanceof Error) {
        this.errorRuta = error.message;
      } else {
        this.errorRuta = 'Error desconocido al calcular la ruta. Intenta nuevamente.';
      }
      this.opcionesRuta = [];
    } finally {
      this.calculandoRuta = false;
      const nombreValido = !!this.nombreNuevaRuta && this.nombreNuevaRuta.trim().length > 0;
      const tieneOpciones = this.opcionesRuta.length > 0;
      console.log('✅ Cálculo finalizado.');
      console.log('   - Nombre válido:', nombreValido, '(valor:', this.nombreNuevaRuta, ')');
      console.log('   - Tiene opciones:', tieneOpciones, '(cantidad:', this.opcionesRuta.length, ')');
      console.log('   - Botón habilitado:', nombreValido && tieneOpciones);
    }
  }

  /**
   * Calcula ruta en modo punto a punto
   */
  private async calcularRutaPuntoAPunto(): Promise<void> {
    if (!this.puntoOrigenSeleccionado || !this.puntoDestinoSeleccionado) {
      this.errorRuta = 'Debe seleccionar un punto de origen y destino';
      return;
    }

    if (this.puntoOrigenSeleccionado.gid === this.puntoDestinoSeleccionado.gid) {
      this.errorRuta = 'El punto de origen y destino no pueden ser el mismo';
      return;
    }

    console.log('🚀 Calculando ruta punto a punto...');
    console.log('🟢 Origen:', this.puntoOrigenSeleccionado.nombre);
    console.log('🔴 Destino:', this.puntoDestinoSeleccionado.nombre);

    this.opcionesRuta = await this.rutasService.calcularRutas(
      this.puntoOrigenSeleccionado,
      this.puntoDestinoSeleccionado
    );

    console.log('✅ Opciones de ruta recibidas (punto a punto):', this.opcionesRuta.length);
    if (this.opcionesRuta.length > 0) {
      console.log('📊 Primera opción:', {
        distancia: this.opcionesRuta[0].getDistanciaKm(),
        duracion: this.opcionesRuta[0].getDuracionMinutos(),
        resumen: this.opcionesRuta[0].resumen
      });
    }
  }

  /**
   * Calcula ruta en modo múltiples puntos (ruta óptima)
   */
  private async calcularRutaMultiplesPuntos(): Promise<void> {
    if (this.puntosMultiplesSeleccionados.length < 2) {
      this.errorRuta = 'Debe seleccionar al menos 2 puntos';
      return;
    }

    console.log('🚀 Calculando ruta óptima para múltiples puntos:', this.puntosMultiplesSeleccionados);
    console.log('📊 Total de puntos seleccionados:', this.puntosMultiplesSeleccionados.length);

    // Calcular ruta con todos los puntos intermedios como waypoints
    const origen = this.puntosMultiplesSeleccionados[0];
    const destino = this.puntosMultiplesSeleccionados[this.puntosMultiplesSeleccionados.length - 1];
    const waypoints = this.puntosMultiplesSeleccionados.slice(1, -1); // Puntos intermedios

    console.log('🟢 Origen:', origen.nombre);
    console.log('🔵 Waypoints (' + waypoints.length + '):', waypoints.map(w => w.nombre));
    console.log('🔴 Destino:', destino.nombre);

    this.opcionesRuta = await this.rutasService.calcularRutas(origen, destino, waypoints);

    console.log('✅ Opciones de ruta recibidas (múltiples puntos):', this.opcionesRuta.length);

    // Actualizar los puntos de origen, destino y waypoints para el guardado
    this.puntoOrigenSeleccionado = origen;
    this.puntoDestinoSeleccionado = destino;

    // Actualizar la vista previa con todos los puntos intermedios
    if (this.opcionesRuta.length > 0) {
      this.opcionSeleccionada = 0;
      console.log('✅ Mostrando ruta temporal con', waypoints.length, 'waypoints');
      this.mostrarRutaTemporalConWaypoints(this.opcionesRuta[0], waypoints);
    } else {
      console.warn('⚠️ No se recibieron opciones de ruta para múltiples puntos');
    }
  }

  /**
   * Calcula ruta en modo selección en mapa
   */
  private async calcularRutaSeleccionMapa(): Promise<void> {
    if (this.puntosMapaSeleccionados.length < 2) {
      this.errorRuta = 'Debe seleccionar al menos 2 puntos en el mapa';
      return;
    }

    console.log('🚀 Calculando ruta con puntos del mapa:', this.puntosMapaSeleccionados);
    console.log('📊 Total de puntos en mapa:', this.puntosMapaSeleccionados.length);

    this.opcionesRuta = await this.rutasService.calcularRutasConCoordenadas(this.puntosMapaSeleccionados);

    console.log('✅ Opciones de ruta recibidas (selección mapa):', this.opcionesRuta.length);

    // Crear puntos temporales de origen y destino para el guardado
    const origen = this.puntosMapaSeleccionados[0];
    const destino = this.puntosMapaSeleccionados[this.puntosMapaSeleccionados.length - 1];

    this.puntoOrigenSeleccionado = {
      gid: 0,
      nombre: `Punto 1 (${origen.lat.toFixed(4)}, ${origen.lng.toFixed(4)})`,
      latitud: origen.lat,
      longitud: origen.lng
    } as any;

    this.puntoDestinoSeleccionado = {
      gid: 0,
      nombre: `Punto ${this.puntosMapaSeleccionados.length} (${destino.lat.toFixed(4)}, ${destino.lng.toFixed(4)})`,
      latitud: destino.lat,
      longitud: destino.lng
    } as any;

    // Actualizar la vista previa con todos los puntos intermedios
    if (this.opcionesRuta.length > 0) {
      const waypoints = this.puntosMapaSeleccionados.slice(1, -1).map((p, idx) => ({
        gid: 0,
        nombre: `Punto ${idx + 2} (${p.lat.toFixed(4)}, ${p.lng.toFixed(4)})`,
        latitud: p.lat,
        longitud: p.lng
      }));

      console.log('🔵 Waypoints del mapa (' + waypoints.length + '):', waypoints);

      this.opcionSeleccionada = 0;
      console.log('✅ Mostrando ruta temporal con', waypoints.length, 'waypoints');
      this.mostrarRutaTemporalConWaypoints(this.opcionesRuta[0], waypoints);
    }
  }

  /**
   * Selecciona una opción de ruta y la muestra en el mapa
   */
  seleccionarOpcionRuta(indice: number): void {
    this.opcionSeleccionada = indice;
    // Actualizar la ruta mostrada en el mapa
    if (this.opcionesRuta[indice]) {
      // Si hay waypoints, usar el método con waypoints
      if (this.modoOperacion === 'multiples-puntos' && this.puntosMultiplesSeleccionados.length > 2) {
        const waypoints = this.puntosMultiplesSeleccionados.slice(1, -1);
        this.mostrarRutaTemporalConWaypoints(this.opcionesRuta[indice], waypoints);
      } else if (this.modoOperacion === 'seleccion-mapa' && this.puntosMapaSeleccionados.length > 2) {
        const waypoints = this.puntosMapaSeleccionados.slice(1, -1).map((p, idx) => ({
          gid: 0,
          nombre: `Punto ${idx + 2} (${p.lat.toFixed(4)}, ${p.lng.toFixed(4)})`,
          latitud: p.lat,
          longitud: p.lng
        }));
        this.mostrarRutaTemporalConWaypoints(this.opcionesRuta[indice], waypoints);
      } else {
        // Modo punto a punto sin waypoints
        this.mostrarRutaTemporalEnMapa(this.opcionesRuta[indice]);
      }
    }
  }

  /**
   * Muestra temporalmente una ruta en el mapa mientras se está creando
   */
  private mostrarRutaTemporalEnMapa(opcion: RutaOpcion): void {
    if (!this.puntoOrigenSeleccionado || !this.puntoDestinoSeleccionado) {
      console.warn('No se pueden mostrar la ruta temporal: faltan puntos de origen o destino');
      return;
    }

    // Crear una ruta temporal para visualización
    const rutaTemporal = new Ruta({
      nombre: 'Vista Previa',
      puntoOrigen: {
        gid: this.puntoOrigenSeleccionado.gid,
        nombre: this.puntoOrigenSeleccionado.nombre,
        latitud: this.puntoOrigenSeleccionado.latitud,
        longitud: this.puntoOrigenSeleccionado.longitud
      },
      puntoDestino: {
        gid: this.puntoDestinoSeleccionado.gid,
        nombre: this.puntoDestinoSeleccionado.nombre,
        latitud: this.puntoDestinoSeleccionado.latitud,
        longitud: this.puntoDestinoSeleccionado.longitud
      },
      puntosIntermedios: [],
      opciones: [opcion],
      rutaSeleccionada: 0,
      visible: true,
      color: '#22C55E' // Color verde suave para la vista previa
    });

    // Emitir la ruta temporal para que se muestre en el mapa
    this.rutasService.setRutaTemporal(rutaTemporal);
  }

  /**
   * Muestra temporalmente una ruta en el mapa con waypoints
   */
  private mostrarRutaTemporalConWaypoints(opcion: RutaOpcion, waypoints: any[]): void {
    if (!this.puntoOrigenSeleccionado || !this.puntoDestinoSeleccionado) {
      console.warn('No se pueden mostrar la ruta temporal: faltan puntos de origen o destino');
      return;
    }

    console.log('🟢 Mostrando ruta temporal con waypoints:', waypoints);

    // Crear una ruta temporal para visualización con todos los waypoints
    const rutaTemporal = new Ruta({
      nombre: 'Vista Previa',
      puntoOrigen: {
        gid: this.puntoOrigenSeleccionado.gid,
        nombre: this.puntoOrigenSeleccionado.nombre,
        latitud: this.puntoOrigenSeleccionado.latitud,
        longitud: this.puntoOrigenSeleccionado.longitud
      },
      puntoDestino: {
        gid: this.puntoDestinoSeleccionado.gid,
        nombre: this.puntoDestinoSeleccionado.nombre,
        latitud: this.puntoDestinoSeleccionado.latitud,
        longitud: this.puntoDestinoSeleccionado.longitud
      },
      puntosIntermedios: waypoints,
      opciones: [opcion],
      rutaSeleccionada: 0,
      visible: true,
      color: '#22C55E' // Color verde suave para la vista previa
    });

    console.log('🗺️ Ruta temporal creada:', rutaTemporal);
    console.log('📍 Puntos intermedios en ruta temporal:', rutaTemporal.puntosIntermedios);

    // Emitir la ruta temporal para que se muestre en el mapa
    this.rutasService.setRutaTemporal(rutaTemporal);
  }

  /**
   * Verifica si puede guardar una ruta manual (sin calcular con API)
   */
  puedeGuardarRutaManual(): boolean {
    return this.modoOperacion === 'seleccion-mapa' && this.puntosMapaSeleccionados.length >= 2;
  }

  /**
   * Verifica si puede guardar la ruta (con o sin calcular)
   */
  puedeGuardarRuta(): boolean {
    // Si estamos editando, no requiere calcular de nuevo
    if (this.rutaEnEdicion) {
      if (this.modoOperacion === 'seleccion-mapa') {
        return this.puntosMapaSeleccionados.length >= 2;
      }
      if (this.modoOperacion === 'multiples-puntos') {
        return this.puntosMultiplesSeleccionados.length >= 2;
      }
      if (this.modoOperacion === 'recorrido-vehiculo') {
        return this.puntosRecorrido.length >= 2;
      }
      // punto-a-punto en edición
      return this.puntoOrigenSeleccionado !== null && this.puntoDestinoSeleccionado !== null;
    }

    // Si es una ruta NUEVA
    if (this.modoOperacion === 'seleccion-mapa') {
      return this.puntosMapaSeleccionados.length >= 2;
    }
    if (this.modoOperacion === 'recorrido-vehiculo') {
      return this.recorridoCargado && this.puntosRecorrido.length >= 2;
    }
    // En otros modos nuevos, REQUIERE haber calculado la ruta
    return this.opcionesRuta.length > 0;
  }

  /**
   * Obtiene el mensaje para el botón de guardar
   */
  obtenerMensajeGuardarRuta(): string {
    if (!this.nombreNuevaRuta) {
      return 'Ingresa un nombre para la ruta';
    }
    if (this.modoOperacion === 'seleccion-mapa') {
      if (this.puntosMapaSeleccionados.length < 2) {
        return 'Selecciona al menos 2 puntos en el mapa';
      }
      return 'Guardar ruta con ' + this.puntosMapaSeleccionados.length + ' puntos';
    }
    // En modo edición, ser más flexible
    if (this.rutaEnEdicion) {
      if (this.modoOperacion === 'multiples-puntos') {
        if (this.puntosMultiplesSeleccionados.length < 2) {
          return 'Selecciona al menos 2 puntos';
        }
        return 'Guardar ruta actualizada con ' + this.puntosMultiplesSeleccionados.length + ' puntos';
      }
      if (this.puntoOrigenSeleccionado && this.puntoDestinoSeleccionado) {
        return 'Guardar cambios';
      }
      return 'Selecciona puntos de origen y destino';
    }
    // Nueva ruta
    if (this.opcionesRuta.length === 0) {
      return 'Calcula la ruta primero';
    }
    return 'Guardar ruta';
  }

  /**
   * Guarda la nueva ruta
   */
  guardarNuevaRuta(): void {
    if (!this.nombreNuevaRuta.trim()) {
      this.errorRuta = 'Debe ingresar un nombre para la ruta';
      return;
    }

    // En modo selección de mapa, permitir guardar sin calcular
    if (this.modoOperacion === 'seleccion-mapa') {
      if (this.puntosMapaSeleccionados.length < 2) {
        this.errorRuta = 'Debe seleccionar al menos 2 puntos en el mapa';
        return;
      }
      this.guardarRutaManual();
      return;
    }

    // En modo recorrido de vehículo, permitir guardar recorrido sin calcular
    if (this.modoOperacion === 'recorrido-vehiculo') {
      if (!this.recorridoCargado || this.puntosRecorrido.length < 2) {
        this.errorRuta = 'Debe cargar un recorrido válido';
        return;
      }
      this.guardarRutaDesdeRecorrido();
      return;
    }

    if (!this.puntoOrigenSeleccionado || !this.puntoDestinoSeleccionado) {
      this.errorRuta = 'Debe seleccionar un punto de origen y destino';
      return;
    }

    // En modo CREAR, REQUIERE haber calculado la ruta
    // En modo EDITAR, NO requiere calcular (puede guardar cambios sin recalcular)
    if (!this.rutaEnEdicion && this.opcionesRuta.length === 0) {
      this.errorRuta = 'Debe calcular la ruta antes de guardar';
      console.log('❌ No hay opciones de ruta. opcionesRuta:', this.opcionesRuta);
      return;
    }

    // Obtener los waypoints según el modo de operación
    // Nota: El modo 'seleccion-mapa' ya fue manejado arriba y retorna antes de llegar aquí
    let puntosIntermedios: any[] = [];

    if (this.modoOperacion === 'multiples-puntos') {
      // Obtener los puntos intermedios (sin el primero y el último)
      puntosIntermedios = this.puntosMultiplesSeleccionados.slice(1, -1).map(p => ({
        gid: p.gid,
        nombre: p.nombre,
        latitud: p.latitud,
        longitud: p.longitud
      }));
    }

    // Si estamos en modo edición, actualizar la ruta existente
    if (this.rutaEnEdicion) {
      console.log('🔄 Actualizando ruta existente:', this.rutaEnEdicion.nombre);

      // Actualizar propiedades de la ruta
      this.rutaEnEdicion.nombre = this.nombreNuevaRuta;
      this.rutaEnEdicion.puntoOrigen = {
        gid: this.puntoOrigenSeleccionado.gid,
        nombre: this.puntoOrigenSeleccionado.nombre,
        latitud: this.puntoOrigenSeleccionado.latitud,
        longitud: this.puntoOrigenSeleccionado.longitud
      };
      this.rutaEnEdicion.puntoDestino = {
        gid: this.puntoDestinoSeleccionado.gid,
        nombre: this.puntoDestinoSeleccionado.nombre,
        latitud: this.puntoDestinoSeleccionado.latitud,
        longitud: this.puntoDestinoSeleccionado.longitud
      };
      this.rutaEnEdicion.puntosIntermedios = puntosIntermedios;
      this.rutaEnEdicion.opciones = this.opcionesRuta;
      this.rutaEnEdicion.rutaSeleccionada = this.opcionSeleccionada;

      // 💾 GUARDAR POLYLINE CALCULADO - Para mostrar sin recalcular
      // En edición, si hay opciones, guardarlas (aunque no hayan sido recalculadas con los nuevos puntos)
      if (this.opcionesRuta.length > 0 && this.opcionesRuta[this.opcionSeleccionada]) {
        const opcionSeleccionada = this.opcionesRuta[this.opcionSeleccionada];
        this.rutaEnEdicion.polyline = opcionSeleccionada.puntos; // Todos los puntos del trayecto
        this.rutaEnEdicion.distanciaMetros = opcionSeleccionada.distancia;
        this.rutaEnEdicion.duracionSegundos = opcionSeleccionada.duracion;
        console.log('💾 Guardando polyline con', opcionSeleccionada.puntos.length, 'puntos del trayecto calculado');
      } else {
        // Si no hay opciones (se cambió de modo sin calcular), mantener los valores anteriores
        console.log('⚠️ Sin opciones recalculadas, manteniendo polyline anterior');
      }

      // Actualizar en el servidor
      this.rutasService.actualizarRutaEnServidor(this.rutaEnEdicion)
        .then(response => {
          console.log('✅ Ruta actualizada exitosamente:', response);
          this.rutasService.clearRutaTemporal();
          this.cancelarNuevaRuta();
          this.errorRuta = '';
        })
        .catch(error => {
          console.error('❌ Error al actualizar ruta:', error);
          this.errorRuta = 'Error al actualizar la ruta en el servidor: ' + (error.message || error);
        });
    } else {
      // 💾 PREPARAR POLYLINE CALCULADO - Para mostrar sin recalcular
      let polylineGuardado = null;
      let distanciaCalculada = 0;
      let duracionCalculada = 0;

      if (this.opcionesRuta.length > 0 && this.opcionesRuta[this.opcionSeleccionada]) {
        const opcionSeleccionada = this.opcionesRuta[this.opcionSeleccionada];
        polylineGuardado = opcionSeleccionada.puntos; // Todos los puntos del trayecto
        distanciaCalculada = opcionSeleccionada.distancia;
        duracionCalculada = opcionSeleccionada.duracion;
        console.log('💾 Preparando polyline con', opcionSeleccionada.puntos.length, 'puntos del trayecto calculado');
        console.log('📊 Distancia:', (distanciaCalculada / 1000).toFixed(2), 'km');
        console.log('⏱️ Duración:', Math.round(duracionCalculada / 60), 'minutos');
      }

      // Crear nueva ruta
      const nuevaRuta = new Ruta({
        nombre: this.nombreNuevaRuta,
        puntoOrigen: {
          gid: this.puntoOrigenSeleccionado.gid,
          nombre: this.puntoOrigenSeleccionado.nombre,
          latitud: this.puntoOrigenSeleccionado.latitud,
          longitud: this.puntoOrigenSeleccionado.longitud
        },
        puntoDestino: {
          gid: this.puntoDestinoSeleccionado.gid,
          nombre: this.puntoDestinoSeleccionado.nombre,
          latitud: this.puntoDestinoSeleccionado.latitud,
          longitud: this.puntoDestinoSeleccionado.longitud
        },
        puntosIntermedios: puntosIntermedios,
        opciones: this.opcionesRuta,
        rutaSeleccionada: this.opcionSeleccionada,
        polyline: polylineGuardado, // ✅ TODOS LOS PUNTOS DEL TRAYECTO
        distanciaMetros: distanciaCalculada,
        duracionSegundos: duracionCalculada,
        visible: true
      });

      // Guardar en el servidor
      console.log('💾 Guardando ruta en el servidor...', nuevaRuta);
      this.rutasService.guardarRutaEnServidor(nuevaRuta)
        .then(response => {
          console.log('✅ Ruta guardada exitosamente:', response);
          this.rutasService.clearRutaTemporal();
          this.cancelarNuevaRuta();
          this.errorRuta = '';
        })
        .catch(error => {
          console.error('❌ Error al guardar ruta:', error);
          this.errorRuta = 'Error al guardar la ruta en el servidor: ' + (error.message || error);
        });
    }
  }

  /**
   * Guarda una ruta manual (sin calcular con API de Google)
   * ==================== 💰 AHORRO DE COSTOS ====================
   * Esta función crea rutas SIN usar Directions API de Google
   * Solo conecta los puntos con líneas rectas
   * Ahorro: $0.005 por cada ruta creada
   * ================================================================
   */
  guardarRutaDesdeRecorrido(): void {
    console.log('💾 Guardando ruta desde recorrido de vehículo...');

    if (this.puntosRecorrido.length < 2) {
      this.errorRuta = 'No hay puntos suficientes en el recorrido';
      return;
    }

    // Crear puntos de origen y destino
    const origen = this.puntosRecorrido[0];
    const destino = this.puntosRecorrido[this.puntosRecorrido.length - 1];

    this.puntoOrigenSeleccionado = {
      gid: 0,
      nombre: `Inicio (${origen.lat.toFixed(4)}, ${origen.lng.toFixed(4)})`,
      latitud: origen.lat,
      longitud: origen.lng
    } as any;

    this.puntoDestinoSeleccionado = {
      gid: 0,
      nombre: `Final (${destino.lat.toFixed(4)}, ${destino.lng.toFixed(4)})`,
      latitud: destino.lat,
      longitud: destino.lng
    } as any;

    // Crear puntos intermedios (cada N puntos para no sobrecargar)
    const salto = Math.max(1, Math.floor(this.puntosRecorrido.length / 50)); // Máx 50 puntos intermedios
    const waypoints: any[] = [];
    for (let i = salto; i < this.puntosRecorrido.length - 1; i += salto) {
      const p = this.puntosRecorrido[i];
      waypoints.push({
        gid: 0,
        nombre: `Punto ${i + 1}`,
        latitud: p.lat,
        longitud: p.lng
      });
    }

    // Calcular distancia total entre puntos consecutivos (distancia real del recorrido)
    let distanciaTotal = 0;
    for (let i = 0; i < this.puntosRecorrido.length - 1; i++) {
      const p1 = this.puntosRecorrido[i];
      const p2 = this.puntosRecorrido[i + 1];
      distanciaTotal += this.calcularDistanciaEntrePuntos(p1.lat, p1.lng, p2.lat, p2.lng);
    }

    // Crear la nueva ruta con el recorrido del vehículo
    const nuevaRuta = new Ruta({
      nombre: this.nombreNuevaRuta,
      puntoOrigen: {
        gid: this.puntoOrigenSeleccionado.gid,
        nombre: this.puntoOrigenSeleccionado.nombre,
        latitud: this.puntoOrigenSeleccionado.latitud,
        longitud: this.puntoOrigenSeleccionado.longitud
      },
      puntoDestino: {
        gid: this.puntoDestinoSeleccionado.gid,
        nombre: this.puntoDestinoSeleccionado.nombre,
        latitud: this.puntoDestinoSeleccionado.latitud,
        longitud: this.puntoDestinoSeleccionado.longitud
      },
      puntosIntermedios: waypoints,
      polyline: this.puntosRecorrido.map(p => ({ lat: p.lat, lng: p.lng })), // Guardar TODOS los puntos del recorrido
      distanciaMetros: distanciaTotal,
      duracionSegundos: 0, // No tenemos duración exacta
      visible: true,
      color: '#3B82F6' // Color azul para rutas desde recorridos de vehículos
    });

    console.log('✅ Ruta desde recorrido creada:', nuevaRuta);
    console.log('📊 Puntos totales en polyline:', this.puntosRecorrido.length);
    console.log('📏 Distancia total: ', (distanciaTotal / 1000).toFixed(2), 'km');

    // Guardar en el servidor
    this.rutasService.guardarRutaEnServidor(nuevaRuta)
      .then(response => {
        console.log('✅ Ruta desde recorrido guardada exitosamente:', response);
        this.rutasService.clearRutaTemporal();
        this.cancelarNuevaRuta();
        this.errorRuta = '';
      })
      .catch(error => {
        console.error('❌ Error al guardar ruta desde recorrido:', error);
        this.errorRuta = 'Error al guardar la ruta: ' + (error.message || error);
      });
  }

  /**
   * Guarda una ruta manual (sin calcular con API de Google)
   * ==================== 💰 AHORRO DE COSTOS ====================
   * Esta función crea rutas SIN usar Directions API de Google
   * Solo conecta los puntos con líneas rectas
   * Ahorro: $0.005 por cada ruta creada
   * ================================================================
   */
  guardarRutaManual(): void {
    console.log('💾 Guardando ruta manual (sin API)...');

    // Crear puntos de origen y destino
    const origen = this.puntosMapaSeleccionados[0];
    const destino = this.puntosMapaSeleccionados[this.puntosMapaSeleccionados.length - 1];

    this.puntoOrigenSeleccionado = {
      gid: 0,
      nombre: `Punto 1 (${origen.lat.toFixed(4)}, ${origen.lng.toFixed(4)})`,
      latitud: origen.lat,
      longitud: origen.lng
    } as any;

    this.puntoDestinoSeleccionado = {
      gid: 0,
      nombre: `Punto ${this.puntosMapaSeleccionados.length} (${destino.lat.toFixed(4)}, ${destino.lng.toFixed(4)})`,
      latitud: destino.lat,
      longitud: destino.lng
    } as any;

    // Crear waypoints con los puntos intermedios
    const waypoints = this.puntosMapaSeleccionados.slice(1, -1).map((p, idx) => ({
      gid: 0,
      nombre: `Punto ${idx + 2} (${p.lat.toFixed(4)}, ${p.lng.toFixed(4)})`,
      latitud: p.lat,
      longitud: p.lng
    }));

    // Crear puntos para la polyline (conectar todos los puntos)
    const puntosPolyline = this.puntosMapaSeleccionados.map(p => ({
      lat: p.lat,
      lng: p.lng
    }));

    // Calcular distancia total (línea recta entre puntos)
    let distanciaTotal = 0;
    for (let i = 0; i < this.puntosMapaSeleccionados.length - 1; i++) {
      const p1 = this.puntosMapaSeleccionados[i];
      const p2 = this.puntosMapaSeleccionados[i + 1];
      distanciaTotal += this.calcularDistanciaEntrePuntos(p1.lat, p1.lng, p2.lat, p2.lng);
    }

    // Crear la nueva ruta sin opciones de API
    const nuevaRuta = new Ruta({
      nombre: this.nombreNuevaRuta,
      puntoOrigen: {
        gid: this.puntoOrigenSeleccionado.gid,
        nombre: this.puntoOrigenSeleccionado.nombre,
        latitud: this.puntoOrigenSeleccionado.latitud,
        longitud: this.puntoOrigenSeleccionado.longitud
      },
      puntoDestino: {
        gid: this.puntoDestinoSeleccionado.gid,
        nombre: this.puntoDestinoSeleccionado.nombre,
        latitud: this.puntoDestinoSeleccionado.latitud,
        longitud: this.puntoDestinoSeleccionado.longitud
      },
      puntosIntermedios: waypoints,
      polyline: puntosPolyline, // Guardar los puntos como polyline
      distanciaMetros: distanciaTotal,
      duracionSegundos: 0, // No calculamos duración en ruta manual
      visible: true,
      color: '#22C55E' // Color verde suave para rutas manuales
    });

    console.log('✅ Ruta manual creada (sin llamada a API):', nuevaRuta);
    console.log('💰 AHORRO: No se llamó a Directions API ($0.005)');

    // Guardar en el servidor
    this.rutasService.guardarRutaEnServidor(nuevaRuta)
      .then(response => {
        console.log('✅ Ruta manual guardada exitosamente:', response);
        this.rutasService.clearRutaTemporal();
        this.cancelarNuevaRuta();
        this.errorRuta = '';
      })
      .catch(error => {
        console.error('❌ Error al guardar ruta manual:', error);
        this.errorRuta = 'Error al guardar la ruta en el servidor: ' + (error.message || error);
      });
  }

  /**
   * Calcula la distancia en metros entre dos puntos usando fórmula de Haversine
   */
  private calcularDistanciaEntrePuntos(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371000; // Radio de la Tierra en metros
    const dLat = this.toRad(lat2 - lat1);
    const dLng = this.toRad(lng2 - lng1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  /**
   * Convierte grados a radianes
   */
  private toRad(degrees: number): number {
    return degrees * (Math.PI / 180);
  }

  /**
   * Cambia la opción de ruta seleccionada para una ruta existente
   */
  cambiarOpcionRuta(ruta: Ruta, indice: number): void {
    ruta.rutaSeleccionada = indice;
    this.rutasService.updateRuta(ruta);
  }

  /**
   * Carga los vehículos disponibles del usuario
   * Obtiene el listado completo de móviles desde el backend
   */
  /**
   * Carga los vehículos disponibles del usuario
   * Obtiene el listado completo de móviles desde el backend
   */
  private cargarVehiculos(): void {
    try {
      // Obtener los vehículos desde el servicio
      this.listaMovilesService.getListaMoviles().subscribe(
        (response: any) => {
          // La respuesta viene como un objeto con los vehículos
          // Convertir el objeto a un array de vehículos
          if (response && typeof response === 'object') {
            this.vehiculosDisponibles = Object.values(response)
              .filter((v: any) => v.cod_equipo_rastreo && v.des_equipo_ratreo)
              .map((v: any) => ({
                cod_equipo_rastreo: v.cod_equipo_rastreo,
                nombre: v.des_equipo_ratreo,
                placa: v.nro_vehiculo || v.matricula || v.des_equipo_ratreo,
                matricula: v.matricula || 'N/A',
                numero_vehiculo: v.nro_vehiculo || 'N/A',
                ...v // Incluir todos los demás campos
              }))
              .sort((a, b) => a.nombre.localeCompare(b.nombre)); // Ordenar alfabéticamente

            console.log('✅ Vehículos cargados:', this.vehiculosDisponibles.length, 'vehículos');
            console.log('📋 Vehículos disponibles:', this.vehiculosDisponibles.map(v => `${v.nombre} (ID: ${v.cod_equipo_rastreo})`));
          } else {
            console.warn('⚠️ Respuesta inesperada de vehículos:', response);
            this.vehiculosDisponibles = [];
          }
        },
        (error) => {
          console.error('❌ Error al cargar vehículos:', error);
          this.errorRuta = 'Error al cargar los vehículos disponibles';
        }
      );
    } catch (error) {
      console.error('❌ Error en cargarVehiculos:', error);
      this.errorRuta = 'Error al cargar vehículos';
    }
  }

  /**
   * Carga el recorrido de un vehículo en un rango de fechas
   */
  /**
   * Carga el recorrido de un vehículo en un rango de fechas
   * Valida que:
   * 1. Se haya seleccionado un vehículo
   * 2. Se hayan ingresado fechas válidas
   * 3. El rango no sea mayor a 24 horas
   */
  cargarRecorrido(): void {
    // Validar que todos los campos estén completos
    if (!this.vehiculoSeleccionado) {
      this.errorRuta = 'Por favor, selecciona un vehículo';
      return;
    }

    if (!this.fechaDesdeRecorrido) {
      this.errorRuta = 'Por favor, selecciona la fecha de inicio';
      return;
    }

    if (!this.fechaHastaRecorrido) {
      this.errorRuta = 'Por favor, selecciona la fecha de fin';
      return;
    }

    // Convertir a objetos Date si no lo son ya
    let desde: Date;
    let hasta: Date;

    try {
      // Manejar tanto string como Date
      desde = typeof this.fechaDesdeRecorrido === 'string'
        ? new Date(this.fechaDesdeRecorrido)
        : this.fechaDesdeRecorrido;

      hasta = typeof this.fechaHastaRecorrido === 'string'
        ? new Date(this.fechaHastaRecorrido)
        : this.fechaHastaRecorrido;

      // Validar que las fechas sean válidas
      if (isNaN(desde.getTime()) || isNaN(hasta.getTime())) {
        this.errorRuta = 'Las fechas ingresadas no son válidas';
        return;
      }
    } catch (error) {
      this.errorRuta = 'Error al procesar las fechas';
      console.error('Error procesando fechas:', error);
      return;
    }

    // Validar que el rango no sea mayor a 24 horas
    const diffMs = hasta.getTime() - desde.getTime();
    const diffHoras = diffMs / (1000 * 60 * 60);

    if (diffHoras > 24) {
      this.errorRuta = 'El rango de fechas no puede ser mayor a 24 horas. Rango actual: ' + Math.round(diffHoras * 10) / 10 + ' horas';
      return;
    }

    if (diffHoras <= 0) {
      this.errorRuta = 'La fecha "Hasta" debe ser posterior a "Desde"';
      return;
    }

    // Validar que el vehículo tenga el ID requerido
    if (!this.vehiculoSeleccionado.cod_equipo_rastreo) {
      this.errorRuta = 'El vehículo seleccionado no tiene ID válido';
      return;
    }

    console.log('🚗 Cargando recorrido para vehículo:', this.vehiculoSeleccionado.nombre);
    console.log('📅 Desde:', desde.toISOString());
    console.log('📅 Hasta:', hasta.toISOString());
    console.log('⏱️ Rango:', diffHoras.toFixed(2), 'horas');

    this.cargandoRecorrido = true;
    this.errorRuta = '';
    this.puntosRecorrido = [];
    this.recorridoCargado = false;

    try {
      const filter = {
        desde: desde.toISOString(),
        hasta: hasta.toISOString()
      };

      // Usar el método getRecorridoMovil con el ID del vehículo
      this.listaMovilesService.getRecorridoMovil(filter, this.vehiculoSeleccionado.cod_equipo_rastreo).subscribe(
        (response: any) => {
          this.cargandoRecorrido = false;

          if (!response) {
            this.errorRuta = 'La respuesta del servidor está vacía';
            console.error('Respuesta vacía del servidor');
            return;
          }

          if (!response.recorrido || response.recorrido.length === 0) {
            this.errorRuta = 'No hay datos de recorrido para el período seleccionado en el vehículo "' + this.vehiculoSeleccionado.nombre + '"';
            console.warn('Sin recorrido en el período:', filter);
            return;
          }

          // Convertir los puntos del recorrido a formato de coordenadas
          try {
            this.puntosRecorrido = response.recorrido
              .filter((punto: any) => punto.latitud && punto.longitud)
              .map((punto: any) => ({
                lat: parseFloat(punto.latitud),
                lng: parseFloat(punto.longitud)
              }))
              .filter((punto: any) => !isNaN(punto.lat) && !isNaN(punto.lng)); // Filtrar coordenadas inválidas
          } catch (error) {
            this.errorRuta = 'Error al procesar los puntos del recorrido';
            console.error('Error procesando puntos:', error);
            return;
          }

          if (this.puntosRecorrido.length === 0) {
            this.errorRuta = 'No hay coordenadas válidas en el recorrido';
            return;
          }

          console.log('✅ Recorrido cargado:', this.puntosRecorrido.length, 'puntos válidos');

          this.recorridoCargado = true;

          // Mostrar los puntos en el mapa
          const puntosTemp = this.puntosRecorrido.map((punto, index) => ({
            numero: index + 1,
            nombre: `Punto ${index + 1}`,
            latitud: punto.lat,
            longitud: punto.lng,
            tipo: index === 0 ? 'origen' :
                  index === this.puntosRecorrido.length - 1 ? 'destino' :
                  'intermedio',
            modo: 'recorrido-vehiculo'
          }));

          this.mapToolsService.setPuntosTemporalesRuta(puntosTemp);
          console.log('🗺️ Puntos mostrados en el mapa');
        },
        (error) => {
          this.cargandoRecorrido = false;
          console.error('❌ Error al cargar recorrido:', error);

          // Proporcionar mejor mensaje de error
          if (error.status === 404) {
            this.errorRuta = 'No se encontraron datos para el vehículo en el período seleccionado';
          } else if (error.status === 400) {
            this.errorRuta = 'Parámetros de búsqueda inválidos';
          } else if (error.status === 500) {
            this.errorRuta = 'Error del servidor al obtener el recorrido';
          } else {
            this.errorRuta = 'Error al cargar el recorrido: ' + (error.message || error.statusText || 'Error desconocido');
          }
        }
      );
    } catch (error) {
      this.cargandoRecorrido = false;
      console.error('❌ Error en cargarRecorrido:', error);
      this.errorRuta = 'Error al cargar el recorrido: ' + (error as any).message;
    }
  }

  /**
   * Actualiza los puntos temporales en el mapa
   * Muestra los marcadores mientras se seleccionan puntos (antes de calcular la ruta)
   */
  private actualizarPuntosTemporales(): void {
    let puntosTemp: any[] = [];

    if (this.modoOperacion === 'multiples-puntos') {
      // Convertir los puntos seleccionados a formato para el mapa
      puntosTemp = this.puntosMultiplesSeleccionados.map((punto, index) => ({
        numero: index + 1,
        nombre: punto.nombre,
        latitud: punto.latitud,
        longitud: punto.longitud,
        tipo: index === 0 ? 'origen' :
              index === this.puntosMultiplesSeleccionados.length - 1 ? 'destino' :
              'intermedio',
        modo: 'multiples-puntos' // Agregar modo
      }));
    } else if (this.modoOperacion === 'seleccion-mapa') {
      // Convertir los puntos del mapa a formato para visualización
      puntosTemp = this.puntosMapaSeleccionados.map((punto, index) => ({
        numero: index + 1,
        nombre: `Punto ${index + 1}`,
        latitud: punto.lat,
        longitud: punto.lng,
        tipo: index === 0 ? 'origen' :
              index === this.puntosMapaSeleccionados.length - 1 ? 'destino' :
              'intermedio',
        modo: 'seleccion-mapa' // Agregar modo
      }));
    }

    console.log('📍 Actualizando puntos temporales:', puntosTemp);
    this.mapToolsService.setPuntosTemporalesRuta(puntosTemp);
  }
}
